import { getShortcutAttrs, TextShortcut } from './shortcut-plugin';
var inlineLeafShortcut = function (regexp, name, config) {
    return new TextShortcut(name, regexp, function (view, state, match, start, end) {
        var nodeType = state.schema.nodes[name];
        if (!nodeType)
            return null;
        var attrs = getShortcutAttrs(config.handler, view, match, start, end);
        if (!attrs)
            return null;
        var marks = view.state.selection.$from.marks();
        return state.tr.replaceWith(start, end, nodeType.create(attrs, undefined, marks));
    }, config);
};
export { inlineLeafShortcut };
//# sourceMappingURL=inline-leaf-shortcut.js.map